import React from 'react';
import { useAuth } from '../hooks/use-auth';
import { Button } from '../components/ui/button';
import { CompanySelector } from './company-selector';
import { useLocation } from 'wouter';

export function Navbar() {
  const { user, logoutMutation } = useAuth();
  const [, setLocation] = useLocation();

  return (
    <nav className="bg-green-50 shadow-sm border-b border-green-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-12">
          <div className="flex items-center">
            <button 
              onClick={() => setLocation('/')}
              className="flex items-center space-x-2 hover:opacity-80 transition-opacity cursor-pointer"
            >
              <img 
                src="/assets/logo_eco.png" 
                alt="Eco Ledger Logo" 
                className="h-6 w-6 object-contain"
                onError={(e) => {
                  // Fallback if logo doesn't exist
                  e.currentTarget.style.display = 'none';
                }}
              />
              <h1 className="text-sm font-semibold text-green-900">
                Eco Ledger
              </h1>
            </button>
          </div>
          
          <div className="flex items-center space-x-3">
            <CompanySelector />
            <button
              onClick={() => setLocation('/pricing')}
              className="text-xs text-green-600 hover:text-green-900 transition-colors"
            >
              Pricing
            </button>
            <span className="text-xs text-green-500">
              Welcome, {user?.full_name || user?.email}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={() => logoutMutation.mutate()}
              disabled={logoutMutation.isPending}
            >
              Logout
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
}
